import React from 'react';
import { FormattedMessage } from 'react-intl';
import Radio from 'components/common/radio-component';

export const LEFT_PANEL_BLOCK = 'left-panel';

const LeftSideRadioOption = ({
  id,
  selectedOption,
  wrapperClassName,
  onChange,
  options,
  tooltip,
  showGuidanceMessage,
  guidanceMessage,
  disabled,
}) => {
  return (
    <div className={wrapperClassName}>
      <Radio
        id={id}
        className={`${LEFT_PANEL_BLOCK}__radio_wrap`}
        radioWrapperClass={`${LEFT_PANEL_BLOCK}__radio`}
        options={options}
        width="auto"
        isValid
        tooltip={tooltip}
        selectedOption={selectedOption}
        onChange={onChange}
        disabled={disabled}
      />
      {showGuidanceMessage && (
        <div className={`${LEFT_PANEL_BLOCK}__guidance-message`}>
          <FormattedMessage id={guidanceMessage} />
        </div>
      )}
    </div>
  );
};

export default LeftSideRadioOption;
